import GameInfoModal from './game-infos-modal';

export default GameInfoModal;
